import { Controller } from "react-hook-form";
import { Input, Select, SelectItem } from "@heroui/react";
import { ThemedText } from "@/components/ui";

const DetailPartyStep = ({
    control,
    errors,
    selectOptions,
    watchMasterCashCategory,
    isEditing,
    setValue,
    isIncome,
}) => {
    const {
        masterCashCategories,
        isLoadingMasterCashCategories,
        masterCashes,
        isLoadingMasterCashes,
        banks,
        isLoadingBanks,
    } = selectOptions;
    const partyLabel = isIncome ? "Pengirim" : "Penerima";
    const sourceLabel = isIncome ? "Tujuan Dana" : "Sumber Dana";

    return (
        <div className="flex flex-col gap-6">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <div className="md:col-span-2">
                    <ThemedText className="font-medium" size="sm">
                        Informasi {partyLabel}
                    </ThemedText>
                    <ThemedText variant="secondary" size="xs">
                        Lengkapi data pihak {partyLabel.toLowerCase()} dana.
                    </ThemedText>
                </div>
                <Controller
                    name="party_name"
                    control={control}
                    rules={{
                        required: `Nama ${partyLabel} wajib diisi`,
                    }}
                    render={({ field }) => (
                        <Input
                            isRequired
                            label={`Nama ${partyLabel}`}
                            placeholder={`Masukkan nama ${partyLabel.toLowerCase()}`}
                            variant="bordered"
                            value={field.value}
                            onValueChange={field.onChange}
                            errorMessage={errors.party_name?.message}
                            isInvalid={!!errors.party_name}
                        />
                    )}
                />
                <Controller
                    name="party_bank_id"
                    control={control}
                    render={({ field }) => (
                        <Select
                            label={`Bank ${partyLabel} (Opsional)`}
                            placeholder="Pilih Bank"
                            variant="bordered"
                            selectedKeys={field.value ? [field.value] : []}
                            onChange={field.onChange}
                            isLoading={isLoadingBanks}
                        >
                            {(banks || []).map((item) => (
                                <SelectItem key={item.value} value={item.value}>
                                    {item.title}
                                </SelectItem>
                            ))}
                        </Select>
                    )}
                />
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <div className="md:col-span-2">
                    <ThemedText className="font-medium" size="sm">
                        {sourceLabel}
                    </ThemedText>
                    <ThemedText variant="secondary" size="xs">
                        Pilih akun kas atau dompet yang menjadi{" "}
                        {sourceLabel.toLowerCase()}.
                    </ThemedText>
                </div>
                <Controller
                    name="master_cash_category_id"
                    control={control}
                    render={({ field }) => (
                        <Select
                            label="Kategori Kas"
                            placeholder="Semua Kategori"
                            variant="bordered"
                            selectedKeys={field.value ? [field.value] : []}
                            onChange={(e) => {
                                field.onChange(e);
                                setValue("master_cash_id", "");
                            }}
                            isLoading={isLoadingMasterCashCategories}
                        >
                            {(masterCashCategories || []).map((item) => (
                                <SelectItem key={item.value} value={item.value}>
                                    {item.title}
                                </SelectItem>
                            ))}
                        </Select>
                    )}
                />
                <Controller
                    name="master_cash_id"
                    control={control}
                    rules={{
                        required: "Kas/Dompet wajib dipilih",
                    }}
                    render={({ field }) => (
                        <Select
                            isRequired
                            label="Kas/Dompet"
                            placeholder="Pilih Kas"
                            variant="bordered"
                            selectedKeys={field.value ? [field.value] : []}
                            onChange={field.onChange}
                            isDisabled={!watchMasterCashCategory && !isEditing}
                            isLoading={isLoadingMasterCashes}
                            errorMessage={errors.master_cash_id?.message}
                            isInvalid={!!errors.master_cash_id}
                        >
                            {(masterCashes || []).map((item) => (
                                <SelectItem key={item.value} value={item.value}>
                                    {item.title}
                                </SelectItem>
                            ))}
                        </Select>
                    )}
                />
            </div>
        </div>
    );
};

export default DetailPartyStep;
